// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { ResourcesManager } from '../../../properties/ResourcesManager';
class _OptionTraderUtils {
    getDaysToExpirationForInstrument(instrument) {
        const daysToExpire = this.getDaysToExpirationForDate(instrument.ContractMonthDate);
        if (daysToExpire === 0) {
            return 1;
        }
        else {
            return daysToExpire;
        }
    }
    getDaysToExpirationForDate(date) {
        const isExpired = date < DateTimeUtils.DateTimeNow();
        const timeDifference = Math.abs(date.getTime() - DateTimeUtils.DateTimeNow().getTime());
        const daysToExpire = Math.floor(timeDifference / (1000 * 3600 * 24));
        return isExpired ? daysToExpire * -1 : daysToExpire + 1;
    }
    formatExpirationDate(date, lang) {
        const locale = lang !== null && lang !== void 0 ? lang : ResourcesManager.getLanguageTag();
        const day = date.getDate();
        const month = date.toLocaleString(locale, { month: 'short' });
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    }
    formatExpirationDateWithDays(date, daysToExpiration) {
        const locale = ResourcesManager.getLanguageTag();
        const formattedDate = this.formatExpirationDate(date, locale);
        const isRtl = ResourcesManager.isRtlLang();
        return isRtl ? `(${daysToExpiration}) ${formattedDate}` : `${formattedDate} (${daysToExpiration})`;
    }
    getNearestExpirationDateIndex(expirationDates) {
        if (!isValidArray(expirationDates)) {
            return -1;
        }
        let selectedDateIndex;
        let selectedSerieDaysTillExpiration;
        for (let i = 0; i < expirationDates.length; i++) {
            const date = new Date(expirationDates[i]);
            const daysToExpiration = OptionTraderUtils.getDaysToExpirationForDate(date);
            if (isNullOrUndefined(selectedDateIndex)) {
                selectedDateIndex = i;
                selectedSerieDaysTillExpiration = daysToExpiration;
            }
            else if (daysToExpiration === 0) {
                selectedDateIndex = i;
                selectedSerieDaysTillExpiration = daysToExpiration;
            }
            else if (selectedSerieDaysTillExpiration < 0) {
                if (daysToExpiration > selectedSerieDaysTillExpiration) {
                    selectedDateIndex = i;
                    selectedSerieDaysTillExpiration = daysToExpiration;
                }
            }
            else if (selectedSerieDaysTillExpiration > 0) {
                if (daysToExpiration > 0 && daysToExpiration < selectedSerieDaysTillExpiration) {
                    selectedDateIndex = i;
                    selectedSerieDaysTillExpiration = daysToExpiration;
                }
            }
        }
        return selectedDateIndex;
    }
}
export const OptionTraderUtils = new _OptionTraderUtils();
